import { Injectable } from '@angular/core';
import { GiftCardService } from './giftcard.service';
import { Observable, Subscriber, of } from 'rxjs';
import { Product } from '../../order/models/product';
import { GiftCard } from '../models/giftcard';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { Guid } from '../../../helpers/Guid';
import { InMemoryGiftCards } from '../models/in-memory-giftcards';


@Injectable()
export class GiftCardInMemoryService implements GiftCardService {

  private _inMemoryGiftCards = new InMemoryGiftCards();

  constructor() {
  }

  get availableGiftCards(): GiftCard[] {
    return this._inMemoryGiftCards.items;
  }

  getGiftCardAvailableAmount(orderNumber: number, giftCardNumber: string, orderAmount: number): Observable<number> {

    if (!giftCardNumber) {
      return of(0);
    }

    const card = this.availableGiftCards.find(x => x.cardNumber === giftCardNumber);
    if (!card || !orderAmount) {
      return of(0);
    }

    return of(Math.min(card.amount, orderAmount));
  }

  getGuestGiftCardAvailableAmount(orderNumber: number, giftCardNumber: string, orderAmount: number): Observable<number> {
    return this.getGiftCardAvailableAmount(orderNumber, giftCardNumber, orderAmount);
  }

  applyOrderGiftCardPayments(orderNumber: number, giftCardRedeems: GiftCard[]): Observable<GiftCard[]> {

    for (const card of giftCardRedeems) {
      const foundCard = this.availableGiftCards.find(x => x.cardNumber === card.cardNumber);
      if (!foundCard) {
        continue;
      }

      foundCard.amount -= card.amount;

      if (foundCard.amount <= 0) {
        this._removeCard(foundCard.cardNumber);
      }
    }

    this._saveGiftCards();

    return of(giftCardRedeems);
  }

  refundGiftCards(orderNumber: number, giftCards: GiftCard[]): Observable<GiftCard[]> {
    return of();
  }

  recalculateGiftCardAmount(orderNumber: number, giftCardNumbers: string[], orderAmount: number): Observable<GiftCard[]> {
    return of();
  }

  guestRecalculateGiftCardAmount(orderNumber: number, giftCardNumbers: string[], orderAmount: number): Observable<GiftCard[]> {
    return of();
  }

  createGiftCard(amount: number): GiftCard {
    const giftCard = this._inMemoryGiftCards.generateNewCard();
    giftCard.amount = amount;
    this.availableGiftCards.push(giftCard);
    this._saveGiftCards();
    return giftCard;
  }

  private _removeCard(cardNumber: string): void {
    const index = this.availableGiftCards.findIndex(x => x.cardNumber === cardNumber);
    if (index > -1) {
      this.availableGiftCards.splice(index, 1);
    }
  }

  private _saveGiftCards(): void {
    this._inMemoryGiftCards.save();
  }

  changeGiftCardAmount(cardName: string, amount: number): void {
    const foundCard = this.availableGiftCards.find(x => x.name === cardName);
    if (foundCard) {
      foundCard.amount = amount;
    }
    this._saveGiftCards();
  }
}
